var map = {
	"./pages/agreements/agreements.module": [
		"./src/app/pages/agreements/agreements.module.ts",
		"pages-agreements-agreements-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"pages-dashboard-dashboard-module"
	],
	"./pages/errors/errors.module": [
		"./src/app/pages/errors/errors.module.ts",
		"pages-errors-errors-module"
	],
	"./pages/forgot-password/forgot-password.module": [
		"./src/app/pages/forgot-password/forgot-password.module.ts",
		"pages-forgot-password-forgot-password-module"
	],
	"./pages/items/items.module": [
		"./src/app/pages/items/items.module.ts",
		"pages-items-items-module"
	],
	"./pages/kbs/kbs.module": [
		"./src/app/pages/kbs/kbs.module.ts",
		"pages-kbs-kbs-module"
	],
	"./pages/register/register.module": [
		"./src/app/pages/register/register.module.ts",
		"pages-register-register-module"
	],
	"./pages/tags-management/tags-management.module": [
		"./src/app/pages/tags-management/tags-management.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;